import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import { getAllAccounts } from "../api/global_collections/accounts";
import { useCurrentUser } from "../hooks/useCurrentUser";

export const globalAccountsKeys = {
  all: ["globalAccounts"] as const,
};

export const useGlobalAccounts = () => {
  const auth0 = useAuth0();
  const currentUser = useCurrentUser();
  return useQuery({
    queryKey: globalAccountsKeys.all,
    queryFn: () => getAllAccounts(currentUser),
    enabled: !!auth0,
    // Optimize caching - only fetch if not already cached
    staleTime: 1000 * 60 * 30, // 30 minutes - data stays fresh for 30 minutes
    gcTime: 1000 * 60 * 60, // 1 hour - keep in cache for 1 hour
    refetchOnWindowFocus: false, // Don't refetch on window focus
    refetchOnReconnect: false, // Don't refetch on reconnect
    refetchInterval: false, // No automatic polling
    // Only refetch if data is stale
    refetchOnMount: true, // Refetch on mount only if data is stale (respects staleTime)
  });
}; 